export default __webpack_public_path__ + "static/media/upload.9aef7884.svg";